import {useCallback, useState} from "react";
import {editHistoryReportExcel, editHistoryReportNew, GetSortingList} from "../../../../Service/service.Parcels";

const useSortingHistoryReportData = () => {
    const [loading, setLoading] = useState(false);
    const [loadingExcel,setLoadingExcel] = useState(false);
    const [error , setError] = useState(null);
    const [data, setData] = useState(null);
    const [dataExport,setDataExport] = useState(null);
    const [dataOutput,setDataOutPut] = useState(null);

    const fetchData = useCallback(
        async (search,page,start_date,end_date) => {
            try{
                setLoading(true);
                let result = await GetSortingList({page: page,maxPage: 20,search: search,start_date: start_date,end_date: end_date});
                // alert(JSON.stringify(result));
                setData(result.result===false?{maxPage:1,result:[],pageNo:1,numRowsAll:0,perPage:20}:result.result);
                setDataOutPut(result.output===false?{numRowsAll:0,pageNo:1,result:[],maxPage:0}:result.output.result);
            }
            catch (e) {
                console.error(e);
                setError('An error occured');
            }
            finally {
                setLoading(false);
            }
        },
        [],
    );

    const fetchDataExcel = useCallback(
        async (search,page,start_date,end_date) => {
            try{
                setLoadingExcel(true);
                let result = await GetSortingList({page: page,maxPage: 0,search: search,start_date: start_date,end_date: end_date});
                // alert(JSON.stringify(result))
                setDataExport(result.data===false?[]:result.data);
            }
            catch (e) {
                console.error(e);
                setError('An error occured');
            }
            finally {
                setLoadingExcel(false);
            }
        },
        [],
    );


    return {
        data,
        dataExport,
        error,
        loading,
        loadingExcel,
        fetchData,
        fetchDataExcel,
        dataOutput
    }
}



export default useSortingHistoryReportData;